<template>
  <LiveNow></LiveNow>
  <div class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8 lg:py-16">
    <div class="max-w-3xl mx-auto text-center">
      <p class="text-sm font-semibold uppercase tracking-wide text-blue">Our convictions</p>
      <h1 class="mt-4 text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">Basis of faith</h1>
      <p class="mt-6 text-lg leading-8 text-gray-600">
        We believe that the good news of Jesus Christ is the foundation of all we are and all we do.
      </p>
    </div>

    <div class="mt-12 rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-200 sm:p-10 lg:p-12">
      <p class="text-xl font-semibold text-gray-900">We believe in...</p>
      <ul class="mt-8 space-y-4 text-lg leading-8 text-gray-700">
        <li>The one true God who lives eternally in three persons — the Father, the Son and the Holy Spirit.</li>
        <li>The love, grace and sovereignty of God in creating, sustaining, ruling, redeeming and judging the world.</li>
        <li>The divine inspiration and supreme authority of the Old and New Testament Scriptures, which are the written Word of God — fully trustworthy for faith and conduct.</li>
        <li>The dignity of all people, made male and female in God’s image to love, be holy and care for creation, yet corrupted by sin, which incurs divine wrath and judgement.</li>
        <li>The incarnation of God’s eternal Son, the Lord Jesus Christ — born of the virgin Mary; truly divine and truly human, yet without sin.</li>
        <li>The atoning sacrifice of Christ on the cross: dying in our place, paying the price of sin and defeating evil, so reconciling us with God.</li>
        <li>The bodily resurrection of Christ, the first fruits of our resurrection; his ascension to the Father, and his reign and mediation as the only Saviour of the world.</li>
        <li>The justification of sinners solely by the grace of God through faith in Christ.</li>
        <li>The ministry of God the Holy Spirit, who leads us to repentance, unites us with Christ through new birth, empowers our discipleship and enables our witness.</li>
        <li>The church, the body of Christ both local and universal, the priesthood of all believers — given life by the Spirit and endowed with the Spirit’s gifts to worship God and proclaim the gospel, promoting justice and love.</li>
        <li>The personal and visible return of Jesus Christ to fulfil the purposes of God, who will raise all people to judgement, bring eternal life to the redeemed and eternal condemnation to the lost, and establish a new heaven and new earth.</li>
      </ul>
    </div>
  </div>

  <MembershipList class="mt-20"></MembershipList>
</template>

<script>
import LiveNow from '@/components/LiveNow.vue'
import MembershipList from '@/components/MembershipList.vue'

export default {
  name: 'Beliefs',
  components: {
    LiveNow,
    MembershipList
  }
}
</script>
